import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VRangeSlider, {
    staticClass: "align-center mt-4",
    attrs: { max: _vm.maxDate, min: _vm.minDate, "hide-details": "" },
    on: { change: _vm.filter },
    scopedSlots: _vm._u([
      {
        key: "prepend",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass: "text-caption",
                staticStyle: { "white-space": "nowrap" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("formatDateYear")(_vm.dates[_vm.dateRange[0]])
                    ) +
                    " "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "append",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass: "text-caption",
                staticStyle: { "white-space": "nowrap" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("formatDateYear")(_vm.dates[_vm.dateRange[1] - 1])
                    ) +
                    " "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }